import React from "react";
import { Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
} from "chart.js";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const MonthlyCommissionChart = ({ data }) => {

    if (!data || data.length === 0) {
        return <p>No commission data available.</p>;
    }

    // Sort by year/month ascending so bars appear chronologically
    const sortedData = [...data].sort((a, b) =>
        a.year === b.year ? a.month - b.month : a.year - b.year
    );

    const labels = sortedData.map((m) => m.monthDisplay);
    const values = sortedData.map((m) =>
        parseFloat(m.amount.replace(/[^0-9.-]+/g, "")) || 0 // strip "$" and commas
    );

    const chartData = {
        labels,
        datasets: [
            {
                label: "Monthly Commission ($)",
                data: values,
                backgroundColor: "#1976d2",
                borderRadius: 6,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: { display: false },
            tooltip: {
                callbacks: {
                    label: (context) =>
                        `$${context.raw.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })}`,
                },
            },
        },
        scales: {
            x: {
                grid: { display: false },
                ticks: { color: "#555" },
            },
            y: {
                beginAtZero: true,
                ticks: {
                    color: "#555",
                    callback: (val) => `$${val.toLocaleString()}`,
                },
            },
        },
    };

    return (
        <div style={{ width: "100%", minHeight: "300px", position: "relative" }}>
            <Bar data={chartData} options={options} />
        </div>
    );
};

export default MonthlyCommissionChart;
